export default "__VITE_ASSET__41d0c5c2__"